import { z } from 'zod/v4';

/**
 * Body of `PATCH /admin/document-types/:id/usage`.
 *
 * Deprecation is its own endpoint rather than a field on the general PATCH:
 * `isDeprecated` is the one flag that hides a type from every picker, so it
 * stays out of the strict `PatchAdminDocumentTypeBodySchema` and cannot be
 * flipped by an ordinary edit.
 */
export const UpdateAdminDocumentTypeUsageBodySchema = z
  .object({
    deprecate: z.boolean(),
  })
  .strict();

export type UpdateAdminDocumentTypeUsageBodyType = z.infer<
  typeof UpdateAdminDocumentTypeUsageBodySchema
>;
